<template>
    <div class="ep-auth-page">
      <div class="auth-result">
          <img src="../../assets/img/control/successs.png" alt="" width="80px" height="80px">
        </div>
      <div class="content-body">
         授权成功
      </div>
    </div>
</template>

<script>

  // 组件化


  export default {
    name: 'authResult',
    data() {
      
    },
    components: {
      
    },
    computed: {
      
    },
    mounted() {
     
    },
    methods: {
      
    }
  }
</script>

<style lang="scss" scoped>
.ep-auth-page{
  text-align: center;
  margin-top: 15%;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}
.content-body {
  font-size: 1.5rem;
}
.auth-result image{
  width: 100%;
}
 
  </style>
  


// WEBPACK FOOTER //
// src/components/control/auth-result.vue